import { observer } from 'mobx-react'
import { FC } from 'react'
import InformationForm from './InformationForm'

const ReturningForm: FC<unknown> = () => {
  return <InformationForm variant={'returning'} />
}

export default observer(ReturningForm)
